<template>
  <div v-if="isCreatedInTargetPeriod && isInDisplayPeriod">
    <div v-if="feedbackNoticeMessage" class="reply-feedback--success feedback">
      <transition name="fade" @enter="enterSuccess">
        <FeedbackSuccess v-if="hasSuccess" :message="feedbackNoticeMessage" />
      </transition>
    </div>
    <div class="new-year__container">
      <div class="new-year__header">
        <div class="new-year__title"></div>
      </div>
      <div class="new-year__lottery-container">
        <div class="new-year__lottery-number-area">
          <div class="new-year__lottery-number-area--title"></div>
          <p class="new-year__lottery-number-area--number">
            {{ lotteryNumber }}
          </p>
        </div>
        <div class="new-year__announcement-area">
          <div class="new-year__announcement-area--title"></div>
          <ButtonPrimary
            class="new-year__announcement-area--button"
            text="当選発表に関する詳細はこちら"
            @click-primary-button="onClickAnnouncementButton"
          />
        </div>
      </div>
      <div class="new-year__notice-area">
        <p class="new-year__notice-area--text">
          ※2026年2月2日までにギフトを保存すると特典が受け取れます。
        </p>
        <p class="new-year__notice-area--text">
          ※ギフトの保存には会員登録（無料）が必要です。
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import dayjs from 'dayjs'
import FeedbackSuccess from '../../atoms/feedbacks/feedback-success.vue'
import ButtonPrimary from '../../molecules/buttons/ButtonPrimary.vue'

export default {
  components: {
    FeedbackSuccess,
    ButtonPrimary
  },
  props: {
    lotteryNumber: {
      type: String,
      require: true,
      default: ''
    },
    token: {
      type: String,
      require: true,
      default: ''
    },
    createdAt: {
      type: String,
      require: true,
      default: ''
    }
  },
  data() {
    return {
      feedbackNoticeMessage: '',
      hasSuccess: false
    }
  },
  computed: {
    isCreatedInTargetPeriod() {
      const formattedCreatedAt = dayjs(this.createdAt)
      return (
        formattedCreatedAt.isSameOrAfter('2025/12/26 15:00:00') &&
        formattedCreatedAt.isSameOrBefore('2026/01/11 23:59:59')
      )
    },
    isInDisplayPeriod() {
      return dayjs().isSameOrBefore('2026/02/02 11:59:59')
    }
  },
  methods: {
    enterSuccess() {
      setTimeout(() => {
        this.hasSuccess = false
      }, 3000)
    },
    onClickCopyButton() {
      const result = navigator.clipboard.writeText(this.token)
      if (result) {
        this.feedbackNoticeMessage = 'コピーしました'
        this.hasSuccess = true
        this.enterSuccess()
      }
      event.preventDefault()
    },
    onClickAnnouncementButton() {
      window.open('/announcements/527', '_blank')
    }
  }
}
</script>
<style lang="scss" scoped>
$yellowish-brown: #bf8400;
$red: #fc2b2b;

.new-year {
  &__container {
    margin-top: 16px;
    padding: 32px 16px;
    background-color: $white;
    background-position: right center;
    background-image: url('../../../../../images/new_year/bg-img.png');
    background-repeat: no-repeat;
    background-size: 100%;
  }

  &__header {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 24px;
    margin-bottom: 16px;
  }

  &__title {
    @include bg-settings(
      '../../../../../images/new_year/new-year-title.svg',
      transparent,
      100%,
      100%
    );
    height: 72px;
    width: 100%;
    margin: 0 8px;
  }

  &__lottery-container {
    background-color: $white;
    border-radius: 8px;
  }

  &__lottery-number-area {
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding: 16px 24px;

    &--title {
      @include bg-settings(
        '../../../../../images/new_year/lottery-number-title.svg',
        $white,
        100%,
        100%
      );
      height: 1.2rem;
    }

    &--number {
      font-style: normal;
      font-weight: 700;
      color: $red;
      text-align: center;
      font-size: 3.2rem;
      line-height: 100%;
    }
  }

  &__announcement-area {
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding: 16px 24px;
    border-top: 1px dashed $gray-2;

    &--title {
      @include bg-settings(
        '../../../../../images/new_year/lottery-results-title.svg',
        $white,
        100%,
        100%
      );
      height: 1.2rem;
    }

    &--button {
      background-color: $yellowish-brown;
    }
  }

  &__notice-area {
    margin-top: 8px;

    &--text {
      font-size: 1rem;
      line-height: 1.6;
      color: $brown-1;
      text-align: left;
    }
  }
}
</style>
